"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var message_const_1 = require("../../const/message.const");
var state_1 = require("./state");
exports.runAsyncFlow = function (commit, _a) {
    var scope = _a.scope, request = _a.request, params = _a.params;
    return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var scoped, response, errors_1, errorTextPath, formattedError;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    scoped = function (value) { return scope ? { scope: scope, value: value } : value; };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    commit('setStatus', scoped('LOADING'));
                    return [4, request.apply(void 0, params)];
                case 2:
                    response = _b.sent();
                    commit('setData', scoped(response));
                    commit('setStatus', scoped('LOADED'));
                    return [2, response];
                case 3:
                    errors_1 = _b.sent();
                    errorTextPath = errors_1.response
                        ? 'response.data.message'
                        : '[0].message';
                    formattedError = {
                        message: lodash_1.get(errors_1, errorTextPath, message_const_1.FALLBACK_MESSAGE.error),
                    };
                    commit('setError', scoped(formattedError));
                    commit('setStatus', scoped('ERROR'));
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
};
exports.withScopes = function (scopes, storeConfig) { return lodash_1.merge(storeConfig, {
    state: lodash_1.reduce(scopes, function (acc, value) {
        var _a;
        return (tslib_1.__assign({}, acc, (_a = {}, _a[value] = tslib_1.__assign({}, state_1.initialState), _a)));
    }, {}),
}); };
exports.createCustomStore = function (getCustomConfig) {
    var config = getCustomConfig({ runAsyncFlow: exports.runAsyncFlow });
    return lodash_1.merge({
        namespaced: true,
        state: tslib_1.__assign({}, state_1.initialState),
        mutations: {
            setStatus: state_1.setStatus,
            setData: state_1.setData,
            setError: state_1.setError,
        },
    }, config);
};
